import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Cliterals(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
    
      <Sides/>
       <Helmet>
 
 <title>Literal in C++ tutorial For Beginners</title>
 <meta name="description" content="Literal in C++ tutorial for beginners.Those value fixed to a variable and refer to fixed values. This is known as literal,CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,Literal in C++ tutorial for beginners,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,cpp literal,c++ string literal,c++ literal suffix,character literal c++,cpp struct literal initialization,cpp raw string literal multi-line,c++ language binary literal,literal constant in c++" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-literal" />
 </Helmet>

 <div className='lg:pl-56'>


    <h1 className="m-4 mh1">Literal in C++</h1>
    <div className="first">
        <a href="/cpp-input"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-operator"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Q-what is literals in c++ programming language?</h2>
   <p className="para mt-4"> <span className="bold">Answer-</span>Those values are fixed to a variable and refer to fixed values. That is known as literal.</p>
    <p className="mt-4 para">1, literal is also known as constants<br/>
2, literal depends upon its type<br/>
3, C++ literals have any primitive data types<br/>
</p>


<h2 className='headingss'>literal in C++ programming language example</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-5"> = "</span>
            <span className="qwerty-3">code exampler</span>
            <span className="qwerty-5">";</span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-5">is a</span>
            <span className="qwerty"> data_types</span>
            {"\n"}
            <span className="qwerty-11"> A </span>
            <span className="qwerty-5">is a </span>
              <span className="qwerty-3">variable</span>
            {"\n"}
            <span className="qwerty-10">= </span>
            <span className="qwerty-5">is an </span>
            <span className="qwerty">operator</span>
            {"\n"}
            <span className="qwerty-10">Code Exampler is a</span>
            <span className="qwerty-5"> C++ string literal</span>
          
           
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>



<h2 className="mt-4 mh2">There are many types of literals:<br/>
</h2>

<h3 className="mt-4 mh3">1, String literals<br/>
2, Integer literals<br/>
3, Float literals<br/>
4, Character literals<br/>
5, Boolean literals<br/>
6, Null literals
</h3>

<h3 className="mt-4">1,String literal in c++ programming language example: <br/></h3>



<h2 className='headings'>Q-Write a program print String literal in c++ programming language Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10">string </span>
            <span className="qwerty-3">a,b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">= "</span>
            <span className="qwerty-5">hello</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-3">b</span>
            <span className="qwerty-2"> = "</span>
            <span className="qwerty">ram</span>
            <span className="qwerty-2">";</span>
            {"\n"} 
            <span className="qwerty-11">  OR  </span>
            {"\n"} 
              <span className="qwerty-10">string</span>
            <span className="qwerty-3"> a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-5">hello</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-10">string </span>
            <span className="qwerty-3">b </span>
            <span className="qwerty-2">= "</span>
            <span className="qwerty">ram</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-4"> cout</span>
              <span className="qwerty-2"> &#60;&#60;</span>
              <span className="qwerty-3">a</span>
              <span className="qwerty-5">+</span>
              <span className="qwerty-2">" "</span>
              <span className="qwerty-5">+</span>
              <span className="qwerty-3">b</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-4"> return</span>
              <span className="qwerty-5"> 0</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
              <span className="qwerty-5">hello </span>
              <span className="qwerty">ram</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>


<h3 className="mt-4 ">2,Integer literal in c++ programming language example:</h3>



<h2 className='headings'>Q-Write a program print integer literal in c++ programming language Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10">int </span>
            <span className="qwerty-3">a,b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-5">10</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">b</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty">200</span>
            <span className="qwerty-2">;</span>
            {"\n"} 
              <span className="qwerty-10">cout</span>
            <span className="qwerty-2"> &#60;&#60;</span>
            <span className="qwerty-3"> a</span>
            <span className="qwerty-2"> + </span>
            <span className="qwerty-3">b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-4"> return</span>
              <span className="qwerty-5"> 0</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
              <span className="qwerty-5">210 </span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>


<h3 className="mt-4 ">3,Float literal in c++ programming language example:</h3>



<h2 className='headings'>Q-Write a program print float literal in c++ programming language example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10">float </span>
            <span className="qwerty-3">a,b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-5">400.8206</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">b</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5">40.25684</span>
            <span className="qwerty-2">;</span>
            {"\n"} 
              <span className="qwerty-10">cout</span>
            <span className="qwerty-2"> &#60;&#60;</span>
            <span className="qwerty-3"> a</span>
            <span className="qwerty-2"> &#60;&#60; "</span>
            <span className="qwerty-3">\n</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-10">cout</span>
            <span className="qwerty-2"> &#60;&#60;</span>
            <span className="qwerty-3"> b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-4"> return</span>
              <span className="qwerty-5"> 0</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
              <span className="qwerty-3">a</span>
              <span className="qwerty-5"> 400.821 </span>
              {"\n"}
              <span className="qwerty-3">b</span>
              <span className="qwerty-5"> 40.2568 </span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>


<h3 className="mt-4">4,Double literal in c++ programming language example:</h3>

<h2 className='headings'>Q-Double literal a and b in c++ programming language example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10">double </span>
            <span className="qwerty-3">a,b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-5">400.8206</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">b</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5">40.25684</span>
            <span className="qwerty-2">;</span>
            {"\n"} 
              <span className="qwerty-10">cout</span>
            <span className="qwerty-2"> &#60;&#60;</span>
            <span className="qwerty-3"> a</span>
            <span className="qwerty-2"> &#60;&#60; "</span>
            <span className="qwerty-3">\n</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-10">cout</span>
            <span className="qwerty-2"> &#60;&#60;</span>
            <span className="qwerty-3"> b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-4"> return</span>
              <span className="qwerty-5"> 0</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
              <span className="qwerty-3">a</span>
              <span className="qwerty-5"> 400.821 </span>
              {"\n"}
              <span className="qwerty-3">b</span>
              <span className="qwerty-5"> 40.2568 </span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>

<h3 className="mt-4">5,Character literals-</h3>
    



<h2 className='headings'>Q-Character literals in c++ programming language example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10">char  </span>
            <span className="qwerty-3">a,b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">a </span>
            <span className="qwerty-2">= '</span>
            <span className="qwerty-5">h</span>
            <span className="qwerty-2">';</span>
            {"\n"}
            <span className="qwerty-3">b</span>
            <span className="qwerty-2"> = '</span>
            <span className="qwerty-5">6</span>
            <span className="qwerty-2">';</span>
            {"\n"} 
              <span className="qwerty-10">cout</span>
            <span className="qwerty-2"> &#60;&#60;</span>
            <span className="qwerty-3"> a</span>
            <span className="qwerty-2"> &#60;&#60; "</span>
            <span className="qwerty-3">\n</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-10">cout</span>
            <span className="qwerty-2"> &#60;&#60;</span>
            <span className="qwerty-3"> b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-4"> return</span>
              <span className="qwerty-5"> 0</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
              <span className="qwerty-3">h</span>
              {"\n"}
              <span className="qwerty-5">6</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>




<h2 className='headings'>Q-Boolean literals in c++ programming language example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-10">bool </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty">true</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-10">bool </span>
            <span className="qwerty-5">b</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-5">a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-11">false</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">Or </span>
            {"\n"}
              <span className="qwerty-10">bool</span>
            <span className="qwerty-5"> a</span>
            <span className="qwerty-2">,</span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-5">a</span>
            <span className="qwerty-2"> =</span>
            <span className="qwerty"> true</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-5">b</span>
              <span className="qwerty-2"> = </span>
              <span className="qwerty-11">false</span>
              <span className="qwerty-2">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-2">That is a</span>\
            <span className="qwerty-4"> Boolean literal in c++</span>
              <span className="qwerty-5"> programming language </span>
              <span className="qwerty-2">example.</span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>



<h3 className="mt-2">Null literals:</h3><br/>
<p className="mt-2 para"> Null literals used to indicate that this object is not available more</p>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-input">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cliterals;